import React, { useState , useRef , useEffect} from "react";
import useStyles from "./style";
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button, 
  TextField,
  Grid,
  Typography,
  CircularProgress,
  MenuItem,
  InputAdornment
} from "@mui/material";

import {Close , LocationOn , Search as SearchIcon} from  "@mui/icons-material";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom'
import { useFormik, useField } from "formik";
import * as yup from "yup";
// Redux
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
// Components 
import Estimatedcarousel from "./Estimatedcarousel"
import DistanceAndRate from "./DistanceDuration"
//Services
import HotelApi from "Services/Hotel";
import { getCountryCodes } from "Utils/country";

const BookingForm = ({setOrigin , setDestination , origin , destination, setMapCenter , services , timezone , userType}) => {

const classes = useStyles();
const dispatch = useDispatch();
const navigate = useNavigate();
const placesLibrary = useMapsLibrary("places");
const [activeTabState, setActiveTabState] = useState('book');
const [pickupLatLng, setPickupLatLng] = useState(null);
const [dropLatLng, setDropLatLng] = useState(null);
const [distance, setDistance] = useState(null);
const [duration, setDuration] = useState(null);
const [travelDuration,setTravelduration] = useState('');
const [activeService, setActiveService] = useState(null);
const [pickupInput, setPickupInput] = useState('');
const [pickupSuggestions, setPickupSuggestions] = useState([]);
const [dropInput, setDropInput] = useState('');
const [dropSuggestions, setDropSuggestions] = useState([]);
const [scheduledTime, setscheduledTime] = useState('');
const autocompleteService = useRef(null);
const placesServiceRef = useRef(null);
const [countryCodeData, setCountryCodeData] = useState([]);
const [loadingCountries, setLoadingCountries] = useState(true);
const [countrySearch, setCountrySearch] = useState("");


useEffect(() => {
if (placesLibrary && !autocompleteService.current) {
  autocompleteService.current = new placesLibrary.AutocompleteService();
}
},[placesLibrary]);

useEffect(() => {
  if (placesLibrary && !placesServiceRef.current && document.getElementById('map-temp')) {
    placesServiceRef.current = new placesLibrary.PlacesService( document.getElementById('map-temp'));
  }
}, [placesLibrary]);

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const countries = getCountryCodes();
        setCountryCodeData(countries);
        setLoadingCountries(false);
      } catch (error) {
        console.error('Error fetching country codes:', error);
        setLoadingCountries(false);
      }
    };

    fetchCountryCodes();
  }, [])

const handlePickupChange = (e) => {
  const value = e.target.value;
  setPickupInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setPickupSuggestions(predictions);
      } else {
        setPickupSuggestions([]);
      }
    });
  } else {
    setPickupSuggestions([]);
  }
};

const handleDropChange = (e) => {
  const value = e.target.value;
  setDropInput(value);
  if (value.length >= 6 && autocompleteService.current) {
    autocompleteService.current.getPlacePredictions({
      input: value
    }, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        setDropSuggestions(predictions);
      } else {
        setDropSuggestions([]);
      }
    });
  } else {
    setDropSuggestions([]);
  }
};

const handlePickupSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setPickupLatLng({ lat, lng });
      setOrigin({ lat, lng }); 
      setPickupInput(description);
      setPickupSuggestions([]);
    }
  });
};

const handleDropSelect = (placeId, description) => {
  placesServiceRef.current.getDetails({ placeId }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      setDropLatLng({ lat, lng });
      setDestination({ lat, lng });
      setDropInput(description);
      setDropSuggestions([]);
    }
  });
};

const handleCancel = () => {
  formik.resetForm();

  setPickupInput("");
  setDropInput("");

  setPickupSuggestions([]);
  setDropSuggestions([]);

  setPickupLatLng(null);
  setDropLatLng(null);

  setOrigin(null);
  setDestination(null);

  setDistance(null);
  setDuration(null);
  setTravelduration("");

  setActiveService(null);
  setscheduledTime("");
};
const handlecreatetrip = (formValues) => {

  formValues.bookingType="HOTEL";
    formValues.tripType = "HOTEL";
    formValues.payment_mode = "HOTEL";   
  formValues.d_address=dropInput;
  formValues.d_latitude=dropLatLng.lat;
  formValues.d_longitude=dropLatLng.lng;
  formValues.distance=distance;
  formValues.minutes=travelDuration;
  formValues.s_address=pickupInput;
  formValues.s_latitude=pickupLatLng.lat;
  formValues.s_longitude=pickupLatLng.lng;
  formValues.service_type=activeService?.service_id;
  formValues.estimatedFare=activeService?.estimated_fare;
  formValues.userType=userType;
  formValues.isScheduled=  activeTabState === 'schedule' ? true : false;
  formValues.scheduledTime=scheduledTime;
 

  console.log('formValues-->',formValues);

    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Ride created successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        navigate('/hoteltriplist');
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while creating ride",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      formik.resetForm();
      const pickupInput = document.getElementById("pickuplocation");
      const dropInput = document.getElementById("droplocation");
    handleCancel();
      if (pickupInput) {
        pickupInput.value = ""; 
        setPickupInput("");
      }
    
      if (dropInput) {
        dropInput.value = ""; 
        setDropInput("");// Clear the value of the drop location field
      }
    };
    HotelApi.createridebyhotel({ ...formValues }).then(onSuccess, onFailure);
};

   const formik = useFormik({
    initialValues: {
      guest_name: "",
      service_type: "",
      s_latitude:"",
      s_longitude:"",
      s_address:"",
      d_latitude:"",
      d_longitude:"",
      d_address:"",
      distance:"",
      minutes:"",
      bookingType:"",
      userNotes:"",
      isScheduled: false,
      scheduledTime: "",
      countryCode:"",
      mobile:"",
      
    },
    validationSchema: yup.object({
      guest_name: yup.string().required("First Name is required").nullable(),
       s_address: yup
        .string()
        .required("Pickup Location is required")
        .nullable(),
      d_address: yup
        .string()
        .required("Drop Location is required")
        .nullable(),
         mobile: yup
                .string()
                .matches(/^\d{1,15}$/, "Invalid mobile number")
                .required("Mobile Number is required")
                .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handlecreatetrip(values); // Ensure this processes `values` correctly
    },
    });

    // console.log("services", services);
    console.log("distance", distance);
    console.log("duration", duration);
// console.log("serviceFares", serviceFares);


 const roundedInputStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
      backgroundColor: "#f5f5f5"
    },
  };

  return (
<>
        
<Box className={classes.bookingformbox} sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>

 <Box className={classes.booking_tabs}>
      <Box
        component="div"
        className={`${classes.tabButton} ${activeTabState === 'book' ? classes.activeTab : classes.inactiveTab}`}
        onClick={() => { setActiveTabState('book');  }}
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        Book Now
      </Box>
      <Box
        component="div"
        className={`${classes.tabButton} ${activeTabState === 'schedule' ? classes.activeTab : classes.inactiveTab}`}
        onClick={() => { setActiveTabState('schedule');  }}
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        Schedule
      </Box>
    </Box>

<div id="map-temp" style={{ display: 'none' }}></div>
<div className={classes.autocomplete_control}>

<Box sx={{ display: "flex", flexDirection: "column", gap: 1, position: "relative", width: "100%" }}>

{/* Pickup Location */}
<Typography variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}>
  Pickup Location
</Typography>
<Box sx={{ display: "flex", alignItems: "center", position: "relative" }}>
{/* <LocationOn sx={{ color: "green", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} /> */}
  <Box sx={{ width: 10, height: 10, borderRadius: '50%', border: '2px solid #22c55e', position: 'absolute', left: 16, top: '19px', transform: 'translateY(-50%)', zIndex: 2 }} />
  <TextField
    id="pickuplocation"
   placeholder="     Search Pickup Point"
    variant="outlined"
    size="small"
    value={pickupInput}
    InputProps={{sx:{ paddingLeft: '20px' }}}
    onChange={(e) => {
    handlePickupChange(e); 
    formik.setFieldValue("s_address", e.target.value); // sync with Formik
  }}
  
  error={Boolean(formik.touched.s_address && formik.errors.s_address)}
  helperText={formik.touched.s_address && formik.errors.s_address}
    className={classes.autocomplete_inputs}
  />

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>    {pickupSuggestions.map((suggestion) => (
      <Box
        key={suggestion.place_id}
        sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
        onClick={() => handlePickupSelect(suggestion.place_id, suggestion.description)}
      >
        {suggestion.description}
      </Box>
    ))}
  </Box>
</Box>

{/* Dotted Line */}
{/* <Box sx={{ height: 18, width: 2, background: "gray", marginLeft: "18px", opacity: 0.5, borderLeft: "2px dotted gray",marginBottom:1 }} /> */}

{/* Drop Location */}
<Typography variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}>
  Dropoff Location
</Typography>
<Box sx={{ display: "flex", alignItems: "center", position: "relative" ,marginBottom: 2 }}>
<LocationOn sx={{ color: "red", position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)" }} />
<Box sx={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', position: 'absolute', left: 16, top: '19px', transform: 'translateY(-50%)', zIndex: 2 }} />
<TextField
id="drop"
placeholder="      Where to go?"
variant="outlined"
size="small"
InputProps={{sx:{ paddingLeft: '20px' }}}
value={dropInput}
onChange={(e) => {
    handleDropChange(e); 
    formik.setFieldValue("d_address", e.target.value);
  }}
  error={Boolean(formik.touched.d_address && formik.errors.d_address)}
  helperText={formik.touched.d_address && formik.errors.d_address}
className={classes.autocomplete_inputs}
/>
  {/* <Button
    size="small"
    sx={{ position: 'absolute', right: 12, top: 8, textTransform: 'none', fontSize: 12, color: '#22c55e', fontWeight: 600 }}
    onClick={() => {/* future: add stop handler */}
 {/* >
    + Add Stop
  </Button> */}

  <Box
  sx={{
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    zIndex: 5,
    background: "#fff",
    boxShadow: 3,
    maxHeight: 200, // Limit height
    overflowY: "auto", // Enable scrolling
  }}
>   {dropSuggestions.map((suggestion) => (
    <Box
      key={suggestion.place_id}
      sx={{ padding: 1, cursor: "pointer", '&:hover': { backgroundColor: "#eee" } }}
      onClick={() => handleDropSelect(suggestion.place_id, suggestion.description)}
    >
      {suggestion.description}
    </Box>
  ))}
</Box>
</Box>


</Box>

<Box container rowSpacing={2} columnSpacing={2} className={classes.containerformik} >
{activeTabState === 'schedule' && (
  <Box item xs={12} className={classes.formikgrids} style={{ marginBottom: "10px" }} >
    <Typography variant="caption" sx={{ display: 'block', marginBottom: 1, fontWeight: 600, color: '#333' }}>
      Select Date and Time
    </Typography>
    <TextField
      id="scheduledTime"
      type="datetime-local"
      value={scheduledTime}
      onChange={(e) => {
        setscheduledTime(e.target.value);
        formik.setFieldValue('scheduledTime', e.target.value);
      }}
      error={formik?.errors?.scheduledTime && formik?.touched?.scheduledTime}
      helperText={formik?.errors?.scheduledTime && formik?.touched?.scheduledTime && formik?.errors?.scheduledTime}
      fullWidth
      variant="outlined"
      size="small"
      className={classes.autocomplete_inputs}
      InputLabelProps={{ shrink: true }}
     
    />
  </Box>
)}

<Grid item xs={12} className={classes.formikgrids} >
  <Typography variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}>
    Guest Name
  </Typography>
 <TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="guest_name"
    placeholder="Enter Guest"
    value={formik?.values?.guest_name}
    defaultValue={formik?.values?.guest_name}
    onChange={formik.handleChange}
    error={
      formik?.errors?.guest_name &&
      formik?.touched?.guest_name
    }
    helperText={
      formik?.errors?.guest_name &&
      formik?.touched?.guest_name &&
      formik?.errors?.guest_name
    }
    fullWidth
   className={classes.autocomplete_inputs}
    size="small"
  ></TextField>
</Grid>

   <Grid item xs={12} className={classes.formikgrids} style={{ marginTop: 8 }}>
          <Typography
           variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}
          >
            Country Code
          </Typography>
          {loadingCountries ? (
            <CircularProgress size={24} />
          ) : (
            <TextField
              name="countryCode"
              id="countryCode"
              className={classes.autocomplete_inputs}
              select
              value={formik?.values?.countryCode || ""}
              onChange={formik?.handleChange}
              error={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode
              }
              helperText={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode &&
                formik?.errors?.countryCode
              }
              
              fullWidth
              variant="outlined"
              size="small"
              SelectProps={{
                displayEmpty: true,
                MenuProps: {
                  autoFocus: false,
                },
              }}
            >
              <MenuItem
                value=""
                disabled
                sx={{ display: "none",color:"#f3f1f1" }}
              >
                Select Country Code
              </MenuItem>

              <div style={{ padding: "8px", position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1 }}>
                <TextField
                  autoFocus
                  size="small"
                  placeholder="Search country..."
                  fullWidth
                  value={countrySearch}
                  onChange={(e) => setCountrySearch(e.target.value)}
                  onClick={(e) => {
                    // Prevent the Select dropdown from closing when clicking inside
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    // Prevent the Select dropdown from closing when typing space and bubbling
                    e.stopPropagation();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              {countryCodeData
                .filter((country) =>
                  country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                  country.code.toLowerCase().includes(countrySearch.toLowerCase()) ||
                  country.dial_code.toLowerCase().includes(countrySearch.toLowerCase())
                )
                .map((country) => (
                  <MenuItem
                    key={country.code}
                    value={country.dial_code}
                  >
                    {`${country.dial_code} ${country.name}`}
                  </MenuItem>
                ))}
            </TextField>
          )}
        </Grid>
        <Grid item xs={12} className={classes.formikgrids} style={{ marginTop: 8 }}>
          <Typography
           variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}
          >
            Mobile Number
          </Typography>
          <TextField
            inputProps={{
              disableUnderline: false,
              form: {
                autocomplete: 'off',
              },
            }}
            id="mobile"
            label="Mobile"
            value={formik?.values?.mobile}
            defaultValue={formik?.values?.mobile}
            onChange={formik.handleChange}
            error={
              formik?.errors?.mobile &&
              formik?.touched?.mobile
            }
            helperText={
              formik?.errors?.mobile &&
              formik?.touched?.mobile &&
              formik?.errors?.mobile
            }
           
            fullWidth
            variant="outlined"
            size="small"
            className={classes.autocomplete_inputs}
          ></TextField>
        </Grid>

<Box item xs={12} className={classes.formikgrids} style={{ marginTop: 8 }} >
    <Typography variant="caption" sx={{ display: 'block', marginBottom: 0.5, fontWeight: 600, color: '#333' }}>
    Add Note to Driver
  </Typography>
 <TextField
    inputProps={{
      disableUnderline: false,
    form: {
          autocomplete: 'off',
        },
    }}
    id="userNotes"
    placeholder="Add your message to your driver"
    value={formik?.values?.userNotes}
    defaultValue={formik?.values?.userNotes}
    onChange={formik.handleChange}
    error={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes
    }
    helperText={
      formik?.errors?.userNotes &&
      formik?.touched?.userNotes &&
      formik?.errors?.userNotes
    }
    multiline
    rows={3}
    fullWidth
    className={classes.textarea_inputs}
    size="small"
    
  ></TextField>
</Box>

</Box>

</div>

{/* distance and duration */}

<DistanceAndRate 
pickupLatLng={pickupLatLng} dropLatLng={dropLatLng} 
origin={origin} destination={destination} distance={distance} duration={duration}
setMapCenter={setMapCenter} setDistance={setDistance} setDuration={setDuration}
 />

{/* Estimated carousel */}

<Estimatedcarousel distance={distance} duration={duration} services={services} 
setTravelduration={setTravelduration} timezone={timezone} setActiveService={setActiveService}/>

          {/* Buttons */}
<Box className={classes.switchWrapper} marginTop={4} >
<Button  fullWidth
  style={{
    height: "50px",
    backgroundColor: "#000",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "15px",
    fontWeight: "100",
    textTransform: "none",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
  }} onClick={() => {
    // formik.setFieldValue("bookingType", "book");
    formik.handleSubmit();
  }}>
Book Now
</Button>
<Button fullWidth rounded style={{
    height: "50px",
    borderRadius: "30px",
    fontSize: "15px",
    fontWeight: "300",
    textTransform: "none",
    boxShadow: "0px 4px 12px rgba(214, 213, 213, 0.15)",
  }} onClick={handleCancel}>
    CANCEL
  </Button>
</Box>
</Box>

</>
  );
};

export default BookingForm;
